import { Button, ButtonLink } from '@packages/shared/src/ui/Button/Button';
import React, { useRef } from 'react';
import { useIntl } from 'react-intl';
import { LoginDialogComposed } from '../LoginDialogComposed/LoginDialogComposed';
import { Link } from '../../Link/Link';

export const LoginDialogButton = (props: { showLogin: boolean; showBackToShop: boolean }) => {
  const { showLogin, showBackToShop } = props;
  const { formatMessage } = useIntl();
  const buttonRef = useRef<HTMLAnchorElement>(null);

  return (
    <div className="flex justify-center gap-2.5 sm:flex-col md:mr-auto md:ml-auto md:flex-row">
      <LoginDialogComposed>
        {showLogin
          ? (openDialog) => (
              <Button variant="color-button" color="primary" onClick={openDialog} size="large">
                {formatMessage({
                  id: 'LoginDialogButton.GoToLogin',
                  defaultMessage: 'Jetzt anmelden',
                })}
              </Button>
            )
          : undefined}
      </LoginDialogComposed>
      {showBackToShop && (
        <ButtonLink
          variant="color-button"
          color={!showLogin ? 'primary' : undefined}
          size="large"
          LinkComponent={Link}
          ref={buttonRef}
          href="/"
        >
          {formatMessage({
            id: 'LoginDialogButton.GoToShop',
            defaultMessage: 'Weiter im Shop',
          })}
        </ButtonLink>
      )}
    </div>
  );
};
